<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">{{routeName}}</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/trendingplaylists" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createPlaylist">
                 <div class="row justify-content-md-center">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-12">
                    <fg-input type="text"
                              v-model="playlist.playlistTitle"
                              label="Title"
                              placeholder="Enter Title"
                              v-validate="rules.playlistTitle"
                              data-vv-name="Title"
                              cus-name="Title"
                              :has-errors="errors"
                              :is-fields="fields">
                    </fg-input>
                  </div>
                  <div class="col-md-12">
                    <fg-input type="text"
                              v-model="playlist.playlistDescription"
                              label="Description"
                              placeholder="Enter Description"
                              v-validate="rules.playlistDescription"
                              data-vv-name="Description"
                              cus-name="Description"
                              :has-errors="errors"
                              :is-fields="fields">
                    </fg-input>
                  </div>
                  <div class="col-md-12">
                    <fg-input type="text"
                              v-model="playlist.csvVideoCodes"
                              label="Video Codes"
                              placeholder="Enter Video Codes (comma separated)"
                              v-validate="rules.csvVideoCodes"
                              data-vv-name="Video Codes"
                              cus-name="Video Codes"
                              :has-errors="errors"
                              :is-fields="fields">
                    </fg-input>
                  </div>
                  <div class="col-md-3" v-if="status.length">
                    <fg-select
                      v-model="playlist.active"
                      label="playlist"
                      v-validate="rules.active"
                      data-vv-name="active"
                      cus-name="active"
                      :has-errors="errors"
                      :is-fields="fields"
                      :list="status"
                      selectedKey="id"
                    >
                    </fg-select>
                  </div>
                </div>
              </div>
              <div class="col-6 text-center">
                <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                  Create Playlist
                </button>
              </div>
            </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'createPlaylist',
        data () {
        return {
            type: '',
            corporations: [],
            corporationsList: [],
            packages: [],
            corps: [],
            playlist: {
              corporationId: 0,
              playlistTitle: '',
              playlistDescription: '',
              csvVideoCodes: ''
            },
          status: [{name:'Select Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
            rules: {
              playlistTitle: {required: true},
              playlistDescription: {required: true},
              csvVideoCodes: {required: true}
            }
        }
    },
    methods: {
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            res.unshift({name: "Select an option"});
            this.corps = res;
            console.log("this.corporations : ", this.corps);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
      createPlaylist () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            console.log("this.playlist : ", this.playlist);

            let createPlaylist = () => {
              this.$store.dispatch('ADD_TPLAYLIST', this.playlist)
                .then((res) => {
                  console.log("ADD_PLAYLIST res : ", res);
                  if (res) this.showPopup('Success!', 'Trending Playlist is successfully created', 'success', () => this.$router.push('/admin/trendingplaylists'))
                  else this.showPopup('Error!', 'Unable to process.', 'error')
                })
                .catch(err => {
                  this.showPopup('Error!', 'Playlist already exitst.', 'error')
                  console.log("ADD_PLAYLIST API error : ", err);
                })
            };
            createPlaylist();
          }

        })
      },
      showPopup(title, msg, popupType, cb){
        this.$swal(title, msg, popupType
        ).then(res => {
          cb && cb();
          return res
        })
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      }
    },
    computed:{
        routeName () {
            const {name} = this.$route;
            return this.capitalizeFirstLetter(name);
        }
    },
    created() {
      this.fetchCorporations();
    }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/TrendingPlaylists/CreateTrendingPlaylist.vue